(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('.cookie-bar');
    if (!bar || !window.Shopify || !window.Shopify.loadFeatures) return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        var privacy = window.Shopify.customerPrivacy;
        if (!privacy || !privacy.shouldShowBanner || !privacy.shouldShowBanner()) return;

        bar.hidden = false;

        bar.addEventListener('click', function (event) {
          var choice = event.target.getAttribute('data-consent');
          if (!choice) return;
          var granted = choice === 'accept';
          privacy.setTrackingConsent(
            {
              analytics: granted,
              marketing: granted,
              preferences: granted,
              sale_of_data: granted
            },
            function (result) {
              if (result && result.error) return;
              bar.hidden = true;
            }
          );
        });
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
